import { render, staticRenderFns } from "./platform_user_detail.vue?vue&type=template&id=2050439a&scoped=true"
import script from "./platform_user_detail.vue?vue&type=script&lang=js"
export * from "./platform_user_detail.vue?vue&type=script&lang=js"
import style0 from "./platform_user_detail.vue?vue&type=style&index=0&id=2050439a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050439a",
  null
  
)

export default component.exports